'use strict';

var FareLadderChartDirective = function FareLadderChartDirective(FareLadderChart) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'FareLadderChartController',
    template: require('../templates/fare-ladder-chart.html'),
    scope: {
      fareLadderData: '='
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new FareLadderChart(chartElement);
      $scope.renderChartDataPresent = function (data) {
        chart.render(data);
      };
    }
  };
};
FareLadderChartDirective.$inject = ['FareLadderChart'];
module.exports = FareLadderChartDirective;